<template>
    <div class="header" v-if="flag" :class="{'headerOpacity':opacityActive}">
        <div class="header-content clearfix">
                <h1><img :src="groupLogo" class="logo-img" :alt="groupName"></h1>
                <div class="fr">
                    <div class="clearfix nav">
                        <h2 class="fl nav-li"><router-link class="nav-link" to="/index.html" title="首页">首页</router-link></h2> 
                        <h2 class="fl nav-li" :class="{'active':item.flag}" v-for="(item,index) in menusList" :key="index">
                            <div class="nav-li-div" v-if="item.subItems.length>0">
                                <router-link  class="nav-link" :to="{path:item.subItems[0].link+'/0.html'}" :title="item.alias">{{item.alias}}</router-link>
                                <div class="nav-child-box" >
                                    <h3 v-for="(sub,index) in item.subItems" :key="index">
                                        <router-link class="nav-child-link" :to="{path:sub.link+'/'+index+'.html'}" :title="sub.name">{{sub.name}}</router-link>
                                    </h3>
                                </div>
                            </div>
                            <div class="nav-li-div" v-else>
                                <router-link  class="nav-link" :to="{path:item.link+'/0.html'}" :title="item.alias">{{item.alias}}</router-link>
                            </div>  
                        </h2>
                    </div>
                </div>            
        </div>            
    </div>   
</template>

<script>
export default {
    data() {
        return {
            groupName:this.$cookies.get(this.api.cachePrex+'GroupName'),
            menusList:[],
            flag:false,
            opacityActive:false
        };
    },
    computed:{
        groupLogo(){
            return this.$store.getters.getGroupLogo;
        }  
    },
    watch: {
      $route(to,from){
        if(this.$route.path == '/index.html'){
           this.flag=false;
        }
        else{
            this.getMenuList();
        }
      }
    },
    created(){
       if(this.$route.path == '/index.html'){
           this.flag=false;
       }
       else{
        this.getMenuList();
       }
    },
    mounted(){
        window.addEventListener('scroll',this.handleScroll)
    },
    methods:{
        handleScroll(){
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
            if(scrollTop>100){
                this.opacityActive=true;
            }
            else{
                this.opacityActive=false;
            }
        },
        getMenuList(){
            this.$axios.post(this.api.index.menus,{},res =>{
                var menusData=res.data;
                var matchUrl;
                for(var i in menusData){
                    // if(menusData[i].subItems.length>0){
                    //     matchUrl=menusData[i].subItems[0].link;
                    // }
                    // else{
                        matchUrl=menusData[i].link;
                    // }
                    if(this.$route.path.indexOf(matchUrl) != -1){
                        menusData[i].flag=true;
                    }
                    else{
                        menusData[i].flag=false;
                    }
                }
                this.menusList=menusData;
                this.flag=true;
            });
        },
    }
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HeaderChild.vue